var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.093,
    height: 23.957,
    viewBox: "0 0 34.093 23.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M35.076,12.7a13.164,13.164,0,0,0-1.409-6.4A4.522,4.522,0,0,0,31,4.757a121.36,121.36,0,0,0-12.963-.48,121.489,121.489,0,0,0-12.916.465A4.445,4.445,0,0,0,2.863,5.887C1.469,7.172,1.315,9.372,1.16,11.23a74.784,74.784,0,0,0,0,10.036,14.79,14.79,0,0,0,.465,3.1,4.863,4.863,0,0,0,1.1,2.106,4.429,4.429,0,0,0,2.308,1.208,69.97,69.97,0,0,0,10.067.511c5.42.077,10.175,0,15.8-.434a4.46,4.46,0,0,0,2.37-1.208A3.856,3.856,0,0,0,34.209,25a16.385,16.385,0,0,0,.805-5.266C35.076,18.865,35.076,13.631,35.076,12.7ZM14.54,20.662V11.075l9.168,4.816C21.138,17.316,17.746,18.927,14.54,20.662Z",
    transform: "translate(-0.991 -4.258)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyoutube);
export default __webpack_public_path__ + "static/media/cyoutube.f37d6724a0802ab9d1cb068ec08ada8e.svg";
export { ForwardRef as ReactComponent };